import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API = "https://reflex-backend.alfaoir1.workers.dev";

export default function SoftwareFormSubmission() {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = () => {
      fetch(`${API}/software-forms`)
        .then((r) => r.json())
        .then((data) => {
          if (data.success) setSubmissions(data.submissions);
          else setError("Failed to load submissions.");
          setLoading(false);
        })
        .catch(() => {
          setTimeout(() => {
            fetch(`${API}/software-forms`)
              .then((r) => r.json())
              .then((data) => {
                if (data.success) setSubmissions(data.submissions);
                else setError("Failed to load submissions.");
                setLoading(false);
              })
              .catch(() => {
                setError("Could not connect to backend.");
                setLoading(false);
              });
          }, 1000);
        });
    };
    loadData();
  }, []);

  const deleteSubmission = (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this submission?")) return;
    fetch(`${API}/software-forms/${id}`, { method: "DELETE" })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setSubmissions((prev) => prev.filter((s) => s._id !== id));
          if (selected?._id === id) setSelected(null);
        } else {
          alert("Failed to delete.");
        }
      })
      .catch(() => alert("Could not connect to backend."));
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.headerTop}>
          <div>
            <p style={s.label}>Admin Panel</p>
            <h1 style={s.title}>Software Form Submissions</h1>
            <p style={s.sub}>Software inquiry & project request responses.</p>
          </div>
          <button style={s.backBtn} onClick={() => navigate("/admin/hiring")}>
            ← Back to Hiring
          </button>
        </div>
      </div>

      <div style={s.content}>
        {loading && <p style={s.msg}>Loading...</p>}
        {error && <p style={s.err}>{error}</p>}

        {!loading && !error && (
          <>
            <p style={s.count}>
              {submissions.length} submission{submissions.length !== 1 ? "s" : ""} received
            </p>

            {submissions.length === 0 ? (
              <p style={s.msg}>No submissions yet.</p>
            ) : (
              <div style={s.layout}>
                <div style={s.tableWrap}>
                  <table style={s.table}>
                    <thead>
                      <tr>
                        <th style={s.th}>#</th>
                        <th style={s.th}>Business Name</th>
                        <th style={s.th}>Contact Name</th>
                        <th style={s.th}>Email</th>
                        <th style={s.th}>Phone</th>
                        <th style={s.th}>Addons</th>
                        <th style={s.th}>Submitted</th>
                        <th style={s.th}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {submissions.map((sub, i) => (
                        <tr
                          key={sub._id}
                          style={{
                            ...s.row,
                            background: selected?._id === sub._id ? "#1a0d2e" : "transparent",
                          }}
                          onClick={() => setSelected(selected?._id === sub._id ? null : sub)}
                          onMouseEnter={e => { if (selected?._id !== sub._id) e.currentTarget.style.background = "#110820"; }}
                          onMouseLeave={e => { if (selected?._id !== sub._id) e.currentTarget.style.background = "transparent"; }}
                        >
                          <td style={s.td}>{i + 1}</td>
                          <td style={{ ...s.td, color: "#a855f7", fontWeight: 600 }}>{sub.business?.businessName || "—"}</td>
                          <td style={s.td}>{sub.business?.contactName || "—"}</td>
                          <td style={s.td}>{sub.business?.email || "—"}</td>
                          <td style={s.td}>{sub.business?.phone || "—"}</td>
                          <td style={s.td}>{sub.addons?.join(", ") || "—"}</td>
                          <td style={s.td}>{sub.submittedAt ? new Date(sub.submittedAt).toLocaleDateString() : "—"}</td>
                          <td style={s.td} onClick={e => e.stopPropagation()}>
                            <button style={s.deleteBtn} onClick={(e) => deleteSubmission(sub._id, e)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {selected && (
                  <div style={s.detail}>
                    <div style={s.detailHeader}>
                      <div>
                        <p style={s.detailName}>{selected.business?.businessName || "—"}</p>
                        <p style={s.detailSub}>{selected.business?.contactName || ""}</p>
                      </div>
                      <button style={s.closeBtn} onClick={() => setSelected(null)}>✕</button>
                    </div>

                    <div style={s.detailSection}>
                      <p style={s.detailSectionLabel}>Contact</p>
                      <p style={s.detailRow}><span style={s.detailKey}>Email</span>{selected.business?.email || "—"}</p>
                      <p style={s.detailRow}><span style={s.detailKey}>Phone</span>{selected.business?.phone || "—"}</p>
                      <p style={s.detailRow}><span style={s.detailKey}>Problems</span>{selected.business?.problems || "—"}</p>
                      <p style={s.detailRow}><span style={s.detailKey}>Notes</span>{selected.business?.notes || "—"}</p>
                      <p style={s.detailRow}><span style={s.detailKey}>Submitted</span>{selected.submittedAt ? new Date(selected.submittedAt).toLocaleString() : "—"}</p>
                    </div>

                    {selected.selections && (
                      <div style={s.detailSection}>
                        <p style={s.detailSectionLabel}>Selections</p>
                        {Object.entries(selected.selections)
                          .filter(([, val]) => val !== "")
                          .map(([key, val]) => (
                            <div key={key} style={s.answerRow}>
                              <span style={s.answerKey}>{key.toUpperCase()}</span>
                              <span style={s.answerVal}>{val}</span>
                            </div>
                          ))}
                        {selected.addons?.length > 0 && (
                          <div style={s.answerRow}>
                            <span style={s.answerKey}>ADDONS</span>
                            <span style={s.answerVal}>{selected.addons.join(", ")}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { background: "#0a0a0f", minHeight: "100vh", color: "#fff", fontFamily: "Inter, sans-serif" },
  header: { background: "linear-gradient(135deg, #0f0a1e, #1a0d2e)", padding: "60px 40px 40px", borderBottom: "1px solid #1f1f2e" },
  headerTop: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: "20px" },
  backBtn: { background: "rgba(124,58,237,0.1)", border: "1px solid rgba(124,58,237,0.3)", color: "#a855f7", padding: "12px 20px", borderRadius: "10px", cursor: "pointer", fontSize: "13px", fontWeight: 700, fontFamily: "Inter, sans-serif", whiteSpace: "nowrap", transition: "all 0.2s" },
  label: { fontSize: "12px", color: "#a855f7", textTransform: "uppercase", letterSpacing: "3px", margin: "0 0 10px" },
  title: { fontSize: "32px", fontWeight: 800, margin: "0 0 8px", letterSpacing: "-0.02em" },
  sub: { fontSize: "15px", color: "#6b7280", margin: 0 },
  content: { maxWidth: "1200px", margin: "0 auto", padding: "40px 20px" },
  count: { fontSize: "13px", color: "#6b7280", marginBottom: "16px" },
  layout: { display: "flex", gap: "24px", alignItems: "flex-start" },
  tableWrap: { overflowX: "auto", flex: 1 },
  table: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", padding: "12px 16px", fontSize: "11px", color: "#6b7280", textTransform: "uppercase", letterSpacing: "1px", borderBottom: "1px solid #1f1f2e" },
  row: { borderBottom: "1px solid #1f1f2e", cursor: "pointer", transition: "background 0.15s" },
  td: { padding: "14px 16px", fontSize: "14px", color: "#d1d5db" },
  msg: { color: "#6b7280", textAlign: "center", padding: "60px 0" },
  err: { color: "#ef4444", background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.2)", borderRadius: "8px", padding: "14px 18px" },
  deleteBtn: { background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.2)", color: "#ef4444", borderRadius: "6px", padding: "5px 12px", cursor: "pointer", fontSize: "12px", fontFamily: "Inter, sans-serif" },
  detail: { width: "340px", flexShrink: 0, background: "#0f0a1e", border: "1px solid #1f1f2e", borderRadius: "14px", padding: "24px", position: "sticky", top: "24px" },
  detailHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px" },
  detailName: { fontSize: "18px", fontWeight: 700, color: "#a855f7", margin: "0 0 4px" },
  detailSub: { fontSize: "12px", color: "#6b7280", margin: 0 },
  closeBtn: { background: "transparent", border: "none", color: "#6b7280", cursor: "pointer", fontSize: "16px", padding: "2px 6px" },
  detailSection: { marginBottom: "20px" },
  detailSectionLabel: { fontSize: "10px", fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: "#a855f7", marginBottom: "10px" },
  detailRow: { fontSize: "13px", color: "#d1d5db", marginBottom: "6px", display: "flex", gap: "8px" },
  detailKey: { color: "#6b7280", minWidth: "70px", fontSize: "12px" },
  answerRow: { display: "flex", flexDirection: "column", gap: "2px", marginBottom: "10px", borderLeft: "2px solid #1f1f2e", paddingLeft: "10px" },
  answerKey: { fontSize: "10px", fontWeight: 700, color: "#7c3aed", letterSpacing: "0.1em" },
  answerVal: { fontSize: "13px", color: "#d1d5db", lineHeight: 1.4 },
};